<nav class="navbar navbar-header fixed-top bg-gradient-primary d-flex">
    <div class="navbar-logo">
        <a routerLink="/panel">
            <img class="img-fluid"
                 src="/assets/images/logo.png"
                 alt="Logo image">
        </a>
        <a href="javascript:void('0');"
           class="collapse-menu ml-lg-autoComplete"
           (click)="onCollapseMenuButtonClick()">
            <i class="fa fa-lg fa-navicon"></i>
        </a>
    </div>
    <a href="javascript:void('0');"
       class="mobile-options"
       (click)="onMobileOptionClick()">
        <i class="fa fa-lg fa-ellipsis-h"></i>
    </a>

    <div class="navbar-right"
         [@openClose]="navRightAnimationState"
         #navRight>
        <div class="common-search mr-auto mr-3 col-xl-4 col-lg-6 col-md-12">
            <div class="input-group input-group-joined">
                <div class="input-category"
                     [ngClass]="{'active':notificationToggled}">
                    <a href="javascript:void('0');"
                       (click)="toggleNotificationBox()">
                        <span class="">{{ commonSearchField | getCommonSearchFields }}</span>
                        <i class="fa fa-angle-down"></i>
                    </a>
                    <app-header-box [toggled]="notificationBoxToggled"
                                    (changeCategory)="commonSearchFieldChanged($event)"
                                    type="notification"
                                    [@openClose]="navRightAnimationState"></app-header-box>
                </div>
                <input [(ngModel)]="commonSearchKeyword"
                       (ngModelChangeDebounced)="commonSearchKeywordChanged($event)"
                       class="form-control mr-sm-2"
                       type="search"
                       placeholder="Search anything here"
                       aria-label="Search">
                <div class="input-group-append">
                    <div class="input-group-text"><i class="fa fa-search"></i></div>
                </div>
            </div>
        </div>
        <ul>
            <li class="header-notification user-profile"
                [ngClass]="{'active':profileToggled}"
                #profileBox>
                <a href="javascript:void('0');"
                   (click)="onLogout()">
                    <span>{{data.profileName}}</span>
                    <i class="fa fa-sign-out"></i>
                </a>
            </li>
        </ul>
    </div>
</nav>
